module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02-m-en.407b65c4fc93f1de9274ac08928524ee.png";